import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { clearCategoryError, fetchCategories } from '../../store/slices/categorySlice';
import { setCategoryFilter, setShouldShowLoader, updateFilter } from '../../store/slices/productSlice';
import Login from '../auth/Login';
import { useAuth } from '../hooks/IsAuth';

const Footer = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { isLoggedIn } = useAuth()
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const { categories, data: categoryData, loading, error } = useSelector((state) => state.category)
  const displayCategories = categoryData?.length ? categoryData : categories?.data || []
  useEffect(() => {
    dispatch(fetchCategories(7))
    return () => {
      dispatch(clearCategoryError())
    }
  }, [dispatch])
  useEffect(() => {
    if (error) {
      console.error("Error fetching categories:", error)
    }
  }, [error])
  const handleLoginClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    openLogin();
  }
  const handleCartClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isLoggedIn) {
      openLogin();
      return
    }
    navigate('/cart-details')
  }
  const handleProtectedLinkClick = (e, path, state = {}) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isLoggedIn) {
      openLogin();
      return;
    }
    navigate(path, { state });
  }
  const openLogin = () => setIsLoginOpen(true);
  const closeLogin = () => setIsLoginOpen(false);
  const handleCategoryClick = (e, cat) => {
    e.preventDefault();
    e.stopPropagation();
     dispatch(setShouldShowLoader(true));
    dispatch(setCategoryFilter(cat?.id));
    navigate('/choose-item-option')
    dispatch(updateFilter({
      filterType: 'categories',
      key: cat?.id,
      value: true
    }));
  }
  return (
    <footer>
      <div className='container'>
        <div className='row gy-4'>
          <div className='col-lg-4'>
            <div className='footer-left'>
              <img src="/image/footer-logo.png" alt='' className='footer-logo' />
              <p className='font-16 mt-4 pe-lg-5'>We're something other than duplicates… What’s more, we do it right! A full administration printing background. Fast print, flyer, and pamphlet printing organization. </p>
              <div className='social mt-lg-5 my-4 mb-lg-0'>
                <h4>Connecting on Social Media</h4>
                <div className='social d-flex align-items-center gap-3 mt-3'>
                  <Link to='#' className=''><img src="/image/instagram.svg" alt='' /></Link>
                  <Link to='#' className=''><img src="/image/facebook-f.svg" alt='' /></Link>
                  <Link to='#' className=''><img src="/image/envelope-alt.svg" alt='' /></Link>
                </div>
              </div>
            </div>
          </div>
          <div className='col-lg-2'>
            <div className='footer-menu'>
              <h4 className='text-uppercase'>Shop</h4>
              <div className='menu-list mt-3'>
                {loading && (
                  <div className="text-center my-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                )}
                {!loading && displayCategories?.length > 0 && (
                  displayCategories.map((category, i) => (<Link key={i} onClick={(e) => handleCategoryClick(e, category)}><img src="/image/footer-angle-right.svg" alt='' /> {category?.title}</Link>)))}
              </div>
            </div>
          </div>
          <div className='col-lg-2'>
            <div className='footer-menu'>
              <h4 className='text-uppercase'>About</h4>
              <div className='menu-list mt-3'>
                <Link to='/about'><img src="/image/footer-angle-right.svg" alt='' /> About</Link>
                <Link to='/faq'><img src="/image/footer-angle-right.svg" alt='' /> Faq’s</Link>
                <Link to='/choose-item-option'><img src="/image/footer-angle-right.svg" alt='' /> Products</Link>
                <Link to='/contact'><img src="/image/footer-angle-right.svg" alt='' /> Contact</Link>
              </div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='footer-menu'>
              <h4 className='text-uppercase'>Let Us Help</h4>
              <div className='menu-list d-flex mt-3'>
                <div className='menu-combo'>
                  <Link to='#' onClick={handleCartClick}><img src="/image/footer-angle-right.svg" alt='' /> Cart</Link>
                  <Link
                    to='#'
                    onClick={(e) => handleProtectedLinkClick(e, '/dashboard', { activeTab: 'profile' })}
                  >
                    <img src="/image/footer-angle-right.svg" alt='' /> My account
                  </Link>
                  <Link
                    to='#'
                    onClick={(e) => handleProtectedLinkClick(e, '/dashboard', { activeTab: 'orders' })}
                  >
                    <img src="/image/footer-angle-right.svg" alt='' /> My orders
                  </Link>
                  <Link
                    to='#'
                    onClick={(e) => handleProtectedLinkClick(e, '/dashboard', { activeTab: 'wishlist' })}
                  >
                    <img src="/image/footer-angle-right.svg" alt='' /> Wishlist
                  </Link>
                </div>
                <div className='menu-combo'>
                  {!isLoggedIn && <Link
                    to='#'
                    onClick={handleLoginClick}
                    className="d-flex align-items-center gap-2 text-decoration-none"
                    style={{ cursor: 'pointer' }}
                  >
                    <img src="/image/footer-angle-right.svg" alt='' />
                    Login/SignUp
                  </Link>}
                  <Link to='/terms-conditions'><img src="/image/footer-angle-right.svg" alt='' /> Terms & Conditions</Link>
                  <Link to='/privacy-policy'><img src="/image/footer-angle-right.svg" alt='' /> Privacy Policy</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='copy-right d-flex flex-wrap align-items-center justify-content-lg-between justify-content-center'>
          <p className='mb-0 font-16'>© My Swag Shack. All Rights Reserved</p>
          <p className='mb-0 font-16'>Powered by: Brain Technosys</p>
        </div>
      </div>
      <Login
        isOpen={isLoginOpen}
        onClose={closeLogin}
      />
    </footer>
  )
}

export default Footer;